import { ChangeDetectionStrategy, Component, model, signal } from '@angular/core';

import type { ICellEditorAngularComp } from 'ag-grid-angular';
import { CheckboxComponent } from '@softline/ui-core';
import { BooleanColumn } from '../../types/grid';
import { filterEmpty, toArray } from '@softline/core';
import type { ICellEditorParams } from 'ag-grid-enterprise';

@Component({
  standalone: true,
  selector: 'soft-boolean-cell-editor',
  imports: [CheckboxComponent],
  styles: `
    :host {
      display: flex;
      width: 100%;
      justify-content: center;
      align-items: center;
    }
  `,
  template: `<soft-checkbox [checked]="value()" (checkedChange)="value.set($event)"></soft-checkbox>`,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BooleanCellEditor implements ICellEditorAngularComp {
  private params!: ICellEditorParams;

  readonly col = signal<BooleanColumn<object> | null>(null);
  value = model<boolean>(false);

  readonly errors = (() => {
    const col = this.col();
    const params = this.params;
    const value = this.value();
    if (!col || !col.validate)
      return [];
    return filterEmpty(toArray(col.validate(value ? 1 : 0, params.data)));
  });

  agInit(params: ICellEditorParams): void {
    this.params = params;
    this.col.set(params['col']);
    const currentValue = params.value ?? false;
    this.value.set(!currentValue);
  }

  refresh(params: ICellEditorParams<any, any>) {
    this.params = params;
    this.col.set(params['col']);
    this.value.set(!!params.value);
  }

  isCancelAfterEnd(): boolean {
    return false;
  }

  getValue(): any {
    return this.value();
  }

  afterGuiAttached(): void {
    setTimeout(() => this.params.stopEditing());
  }
}
